<template>
	<router-view/>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss">
html,body{
	padding:0;
	margin:0;
}
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #333333;
}
</style>
